// Firebase Web SDK configuration
// Web uses REST API, but SDK still needed for auth and mobile compatibility
import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { monitorFirebaseWebSocket, exposeWebSocketGlobals } from './websocketMonitor';

const firebaseConfig = {
  apiKey: "AIzaSyA-ZoLrIZy10-lsoxo4m3SL9zRI1oTaoTI",
  authDomain: "pyxida-e6211.firebaseapp.com",
  databaseURL: "https://pyxida-e6211-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "pyxida-e6211",
  storageBucket: "pyxida-e6211.appspot.com",
  messagingSenderId: "953737634109",
  appId: "1:953737634109:web:ff1ba3bda52a99a6336554",
  measurementId: "G-K7TQDJBLNV",
};

// Initialize Firebase
let app: any = null;
let firestoreInstance: any = null;
let authInstance: any = null;
let firestoreNetworkEnabled = false;
let firestoreNetworkPromise: Promise<void> | null = null;
let firestoreSynced = false;
let snapshotsInSyncUnsubscribe: (() => void) | null = null;

// Initialize Firebase immediately at module load time
function initializeAppAtModuleLoad() {
  console.log('🔧 [CONFIG] initializeAppAtModuleLoad() called');
  try {
    const existingApps = getApps();
    console.log('✅ [CONFIG] getApps() returned:', existingApps.length, 'apps');
    if (existingApps.length > 0) {
      console.log('ℹ️ [CONFIG] Firebase app already exists at module load');
      app = existingApps[0];
    } else {
      console.log('🔧 [CONFIG] Initializing Firebase Web SDK at module load with project:', firebaseConfig.projectId);
      app = initializeApp(firebaseConfig);
      console.log('✅ [CONFIG] Firebase Web SDK initialized at module load, app=', app?.name);
    }
    console.log('✅ [CONFIG] Firebase app is now available:', app ? 'YES' : 'NO');
  } catch (error) {
    console.error('❌ [CONFIG] Failed to initialize Firebase at module load:', error);
    app = null;
  }
}

// Log module load
console.log('🔥 [CONFIG] firebase-web/config.ts module is loading...');

// Enable WebSocket monitoring for debugging real-time connection issues
monitorFirebaseWebSocket();
exposeWebSocketGlobals();

// Run initialization immediately when this module loads
if (typeof window !== 'undefined') {
  console.log('🔥 [CONFIG] Window is defined, calling initializeAppAtModuleLoad()');
  initializeAppAtModuleLoad();
} else {
  console.log('⚠️ [CONFIG] Window is not defined, deferring initialization');
}

export function initializeFirebaseWeb() {
  if (!app) {
    console.log('🔧 [CONFIG] Initializing Firebase Web SDK with project:', firebaseConfig.projectId);
    const existingApps = getApps();
    if (existingApps.length > 0) {
      app = existingApps[0];
    } else {
      app = initializeApp(firebaseConfig);
    }
    console.log('✅ [CONFIG] Firebase Web SDK initialized');
    console.log('📱 [CONFIG] App instance:', app);
  } else {
    console.log('ℹ️ [CONFIG] Firebase already initialized');
  }
  return app;
}

export function getFirestoreWeb() {
  console.log('🔍 [CONFIG] getFirestoreWeb() called');
  if (!app) {
    console.log('⚠️ [CONFIG] App not initialized, initializing now...');
    initializeFirebaseWeb();
  }
  if (!app) {
    console.log('❌ [CONFIG] Firebase initialization failed - returning null');
    return null;
  }
  if (!firestoreInstance) {
    console.log('📦 [CONFIG] Getting Firestore instance');
    try {
      firestoreInstance = getFirestore(app);
      console.log('✅ [CONFIG] Firestore instance obtained');
    } catch (e) {
      console.error('❌ [CONFIG] Failed to get Firestore instance:', e);
      return null;
    }
  } else {
    console.log('ℹ️ [CONFIG] Firestore already initialized');
  }
  return firestoreInstance;
}

export function getAuthWeb() {
  if (!app) {
    initializeFirebaseWeb();
  }
  if (!app) {
    console.log('❌ [CONFIG] Firebase initialization failed - returning null');
    return null;
  }
  if (!authInstance) {
    authInstance = getAuth(app);
    console.log('✅ [CONFIG] Auth instance created (unauthenticated access enabled via Firestore rules)');
  }
  return authInstance;
}

/**
 * Check if Firebase is initialized and ready to use
 */
export function isFirebaseReady(): boolean {
  return app !== null;
}
